export const scenariosSelector = (state) => state.testingExercisingReducer.scenarios || [];
export const industryNameSelector = (state) => state.testingExercisingReducer.industryName;
export const industryIdSelector = (state) => state.testingExercisingReducer.industryId;
export const industriesSelector = (state) => state.testingExercisingReducer.industries || [];
export const usingMockSelector = (state) => state.testingExercisingReducer.usingMock;
export const loadingScenariosSelector = (state) => state.testingExercisingReducer.loadingScenarios;
export const scenarioSubmissionsSelector = (state) => state.testingExercisingReducer.scenarioSubmissions || [];
export const scenarioSubmissionsMetaSelector = (state) => state.testingExercisingReducer.scenarioSubmissionsMeta;
export const loadingSubmissionsSelector = (state) => state.testingExercisingReducer.loadingSubmissions;
export const submissionDetailSelector = (state) => state.testingExercisingReducer.submissionDetail;
export const loadingSubmissionDetailSelector = (state) => state.testingExercisingReducer.loadingSubmissionDetail;
export const submissionRequestSelector = (state) => state.testingExercisingReducer.submissionRequest;

export function scenarioByIdSelector(state, scenarioId) {
  const id = Number(scenarioId);
  return scenariosSelector(state).find((item) => Number(item.scenarioId) === id) || null;
}
